import Navbar from "../../components/Navbar";
import AboutUs from "./AboutUs";
import Contact from "./Contact";
import Footer from "./Footer";
import HeroSection from "./Hero";
import OverlappingCards from "./Overlap";
import StatsSection from "./Stats";

const LandingPage = () => {
  return (
    <div className="min-h-screen
     flex flex-col justify-between relative overflow-x-hidden">
      {/* Make the Navbar fixed with a high z-index */}
      <Navbar className="" />

      {/* Add padding to prevent content from being hidden under the fixed Navbar */}
      <main className="">
        {" "}
        {/* Adjust `pt-20` to match the Navbar's height */}
        <HeroSection />
        <OverlappingCards />
        <AboutUs  />
        <StatsSection />
        <Contact />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;
